const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/pages/ErrorPage/styles.ts';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

export function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            page: css`
                display: flex;
                flex-direction: column;
                height: 100%;
                width: 100%;
                padding: ${theme.spacing(2, 3, 0, 3)};
                background-color: ${theme.palette.background.default};

                ${theme.breakpoints.up('xs')} {
                    padding: ${theme.spacing(10, 15)};
                    align-self: center;
                }
            `,
            mainContent: css`
                flex: 10;
                display: flex;
                justify-content: center;
                flex-direction: column;

                ${theme.breakpoints.up('xs')} {
                    padding-right: ${theme.spacing(15)};
                    align-self: center;
                }
            `,
            button: css`
                flex: 1;

                ${theme.breakpoints.up('xs')} {
                    align-self: flex-end;
                }
            `,
            icon: css`
                color: ${theme.palette.text.secondary};
                align-self: flex-start;
                font-size: 48px;
            `,
            mainMessage: css`
                display: flex;
                flex-direction: column;
                margin-top: ${theme.spacing(2)};
                margin-bottom: ${theme.spacing(2)};
            `,
        }),
        [theme]
    );
}
